document.addEventListener('DOMContentLoaded', function () {
  const containerHeadLinks = document.querySelector('.locator-container')
  if (!containerHeadLinks) return

  const submenuHeadLinks = document.querySelector('.nav-submenu')
  if (!submenuHeadLinks) return

  // get all h2 and h3
  const headingsHeadLinks = containerHeadLinks.querySelectorAll('h2, h3')

  if (headingsHeadLinks) {
    const headingMap = new Map()

    headingsHeadLinks.forEach((heading, index) => {
      // Generate a unique ID if the heading doesn't already have one
      if (!heading.id) {
        heading.id = 'heading-' + index
      }

      // Create a new list item with a link
      const listItem = document.createElement('li')
      const link = document.createElement('a')
      link.href = '#' + heading.id
      link.innerHTML = `${heading.textContent}<span aria-hidden="true" class="szicon-arrow-right"></span>`
      listItem.appendChild(link)

      // Append the list item to the submenu
      submenuHeadLinks.appendChild(listItem)

      // Map the heading ID to the list item
      headingMap.set(heading.id, link)

      // Add click event to update the active class
      link.addEventListener('click', function () {
        updateActiveClass(link)
      })
    })

    // Function to update the active class
    function updateActiveClass(activeLink) {
      submenuHeadLinks.querySelectorAll('a').forEach((link) => {
        link.classList.remove('is-active')
      })
      activeLink.classList.add('is-active')
    }

    // Function to handle scroll event
    function onHeadLinksScroll() {
      let fromTop = window.scrollY + 100 // Add some offset

      let currentHeading = null

      headingsHeadLinks.forEach((heading) => {
        const headingTop = heading.getBoundingClientRect().top + window.scrollY
        if (headingTop <= fromTop) {
          currentHeading = heading
        }
      })

      if (currentHeading) {
        const link = headingMap.get(currentHeading.id)
        updateActiveClass(link)
      }
    }

    // Attach scroll event listener
    window.addEventListener('scroll', onHeadLinksScroll)

    // Initial call to set the active class based on the initial scroll position
    onHeadLinksScroll()
  }
})

// prevent the hash in the URL bar for named anchor links
document.addEventListener('DOMContentLoaded', function () {
  const anchorLinksHeadLinks = document.querySelectorAll('.nav-submenu a[href^="#"]:not([href="#"])')

  anchorLinksHeadLinks.forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault()

      const targetId = this.getAttribute('href').substring(1)
      const targetElement = document.getElementById(targetId)

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth'
        })
      }
    })
  })
})
